import { useSorts } from "../../Common/Hooks/useSorts"
import Sorting from "../Sorting"
import { TurnsLink } from "../Filtering/TurnsLink"
import { Play } from "../../Common/SI"
import { SortToggle } from "../SortToggle"

export interface TurnOutcomeTableProps {
	plays: Play[]
}

export function TurnOutcomeTable(props: TurnOutcomeTableProps): JSX.Element {

	const table = 'TurnOutcome'

	const { sorts } = useSorts()
	const sort = sorts.get(table) || { field: 'turnCount', ascending: true }

	const minTurns = 1
	const maxTurns = 12

	const tableData: TableRow[] = []
	for (let turnCount = minTurns; turnCount <= maxTurns; turnCount++) {
		tableData.push({
			turnCount,
			lossCount: null,
			playCount: null,
			winCount: null,
			winRate: null,
		})
	}

	for (const play of props.plays) {
		if (play.turns === null || play.turns < minTurns || play.turns > maxTurns) {
			continue
		}

		const row = tableData[play.turns - minTurns]

		if (row.lossCount === null) { row.lossCount = 0 }
		if (row.winCount === null) { row.winCount = 0 }

		if (play.outcome.victory) {
			row.winCount++
		} else {
			row.lossCount++
		}
	}

	for (const row of tableData) {
		if (row.lossCount === null) {
			continue
		}

		row.playCount = row.winCount! + row.lossCount!
		row.winRate = row.winCount! / row.playCount
	}

	Sorting.sort(tableData, sort, 'turnCount')

	return (
		<div>
			<table className="stats turn-outcomes">
				<thead>
					<tr>
						<th>
							<SortToggle table={table} field={'turnCount'} label='Turns' defaultAscending={true} />
						</th>
						<th>
							<SortToggle table={table} field={'winCount'} label='W' />
						</th>
						<th>
							<SortToggle table={table} field={'lossCount'} label='L' />
						</th>
						<th>
							<SortToggle table={table} field={'playCount'} label='Total' />
						</th>
						<th>
							<SortToggle table={table} field={'winRate'} label='Win %' />
						</th>
					</tr>
				</thead>
				<tbody>
					{
						tableData.map(row =>
							<tr key={row.turnCount}>
								<th><TurnsLink turns={row.turnCount} /></th>
								<td className='victory'>{row.playCount ? row.winCount : ''}</td>
								<td className='loss'>{row.playCount ? row.lossCount : ''}</td>
								<td>{row.playCount || ''}</td>
								<td>{row.winRate ? `${(100 * row.winRate).toFixed(1)}%` : ''}</td>
							</tr>
						)
					}
				</tbody>
			</table>
		</div>
	)
}

interface TableRow {
	turnCount: number
	lossCount: number | null
	playCount: number | null
	winCount: number | null
	winRate: number | null
}
